import { render, staticRenderFns } from "./match.vue?vue&type=template&id=045a7435&scoped=true&"
import script from "./match.vue?vue&type=script&lang=ts&"
export * from "./match.vue?vue&type=script&lang=ts&"
import style0 from "./match.vue?vue&type=style&index=0&id=045a7435&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a7435",
  null
  
)

export default component.exports